require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2005-09-25-need-beta-testers.json") })
        }
      }, "path---articles-2005-09-25-need-beta-testers");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2005-09-25-need-beta-testers!./.cache/json/articles-2005-09-25-need-beta-testers.json
// module id = 429
// module chunks = 231608221292675